import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface ScenarioComparisonCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ScenarioComparisonCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: ScenarioComparisonCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">Scenario Comparison</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <Badge className="bg-green-600">Base</Badge>
                <span className="text-sm font-medium">Current Plan</span>
              </div>
              <span className="text-sm font-semibold">£287k</span>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <Badge variant="outline">Alt</Badge>
                <span className="text-sm">Aggressive Growth</span>
              </div>
              <span className="text-sm font-semibold">£245k</span>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <Badge variant="outline">Alt</Badge>
                <span className="text-sm">Conservative</span>
              </div>
              <span className="text-sm font-semibold">£312k</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
